import React, { Component } from 'react';
import { connect } from "react-redux";

import './../../../../scss/App.scss';
import { trackingWrapper } from '../../../utils/analytics';
import { setAffiliate } from '../../../actions';

const EXTERNAL_LINK = 'https://vupulse.com/c/3232';

class TuneIn extends Component {

	constructor(props){
		super(props);

		this.transitionIn = new window.TimelineMax();

		this.state = {

		}
	}

	componentDidMount(){

		window.TweenMax.set(this.refs.wipe, {"width":"100%"});
		window.TweenMax.set(this.refs.host, {"height":"0%"});
		window.TweenMax.set(this.refs.tuneIn, {"alpha":"0", "transform":"translateY(1vw)"});
		// window.TweenMax.set(this.refs.dvrBtn, {"alpha":"0", "transform":"translateY(1vw)"});

		this.transitionIn.to(this.refs.wipe, .4, {"width": "0%"})
			.to(this.refs.host, .5, {"height":"100%"}, "-=.2")
			.to(this.refs.tuneIn, .5, {"alpha":"1", "transform":"translateY(0vw)"}, "-=.2");
			// .to(this.refs.dvrBtn, .5, {"alpha":"1", "transform":"translateY(0vw)"}, "-=.2");

	}

	componentDidUpdate(prevProps, prevState){

		if(this.props.landingTransitionOut === true && prevProps.landingTransitionOut === false){
			this.transitionIn.reverse();
		}
	}

	handleClick(evt) {
		evt.preventDefault();
		evt.stopPropagation();

		trackingWrapper('event', 'ASGame-external-link', {'event_label':'vupulse','event_category':'america-says-game'});
		window.open(EXTERNAL_LINK, '_blank');
	}

	render() {
		const {
			affiliate
		} = this.props;

		return (
			 <div id="tuneIn">
				 <div className="tuneIn" ref="tuneIn"></div>
				 {affiliate !== null &&
					<img className="affiliateLogo" src={"images/" + affiliate.imgName } />
				 }
				 <div className="host" ref="host"></div>
				 {
					//  <a className="dvrBtn" ref="dvrBtn" href={EXTERNAL_LINK} onMouseOver={() => window.sounds.buttonHover.play()} onClick={this.handleClick} target="_blank">Click to DVR<span className="fas fa-caret-right"></span></a>
				 }
		 		<div className="wipe" ref="wipe"></div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
  affiliate: state.affiliate
});

const mapDispatchToProps = dispatch => ({
  setAffiliate: data => {
    dispatch(setAffiliate(data));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TuneIn);



// WEBPACK FOOTER //
// ./src/js/components/landingpage/leftCol/TuneIn.js